import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexAnnouncementRequest = ({ dispatch, params, successCallback, callback }) => {
  ApiService.request('get', '/announcements', {
    dispatch,
    params,
    successCallback,
    callback
  });
};

export const showAnnouncementRequest = (id, { dispatch, params, successCallback, callback }) =>
  ApiService.request('get', `/announcements/${id}`, {
    dispatch,
    params,
    successCallback,
    callback
  });

export const createAnnouncementRequest = ({ dispatch, params, successCallback, callback }) =>
  ApiService.request('post', '/announcements', {
    dispatch,
    params,
    formData: true,
    successCallback,
    callback
  });

export const updateAnnouncementRequest = (id, { dispatch, params, successCallback, callback }) =>
  ApiService.request('put', `/announcements/${id}/`, {
    dispatch,
    params,
    formData: true,
    successCallback,
    callback
  });

export const deleteAnnouncementRequest = (id, { dispatch, successCallback, callback }) =>
  ApiService.request('delete', `/announcements/${id}`, {
    dispatch,
    successCallback,
    callback
  });

export const debounceIndexAnnouncementRequest = AwesomeDebouncePromise(indexAnnouncementRequest, 300);
